import React from 'react';
import Button from '@atlaskit/button';
import { ActionItem, Actions, Footer } from '../styled/Content';
const JustifyShim = (props) => React.createElement("span", Object.assign({}, props));
export default class ModalFooter extends React.Component {
    render() {
        const { actions, appearance, component, onClose, showKeyline } = this.props;
        const warning = 'You can provide `component` OR `actions`, not both.';
        if (!component && !actions)
            return null;
        if (component && actions) {
            console.warn(warning); // eslint-disable-line no-console
            return null;
        }
        if (component) {
            return React.createElement(component, {
                appearance,
                onClose,
                showKeyline,
            });
        }
        return (React.createElement(Footer, { showKeyline: showKeyline },
            React.createElement(JustifyShim, null),
            React.createElement(Actions, null, actions
                ? actions.map(({ text, ...rest }, index) => {
                    const variant = index !== 0 ? 'subtle' : appearance || 'primary';
                    return (
                    // Index used as text can be a ReactNode
                    React.createElement(ActionItem, { key: index },
                        React.createElement(Button, Object.assign({ appearance: variant }, rest), text)));
                })
                : null)));
    }
}
//# sourceMappingURL=Footer.js.map